import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Modal,
  Nav,
  Navbar,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import MenuIcon from "../assets/svg/MenuIcon";
import ProfileIcon from "../assets/svg/ProfileIcon";
import BetIcon from "../assets/svg/BetIcon";
import StatementIcon from "../assets/svg/StatementIcon";
import LogoutIcon from "../assets/svg/LogoutIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import logo from "../assets/svg/logo_new.png";
import UserIcon from "../assets/images/icons/user.png";
import numberWithCommas from "../utils/numbersWithComma";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { CasinoProviders } from "../lib/data";
import { getExposureAmount } from "../redux/auth/actions";
import { getBetMatches, getUserBet } from "../redux/sports/actions";
import BotHeadIcon1 from "../assets/images/icons/new/InPlay.png";
import BotHeadIcon2 from "../assets/images/icons/new/cricket.png";
import BotHeadIcon4 from "../assets/images/vivo/icons/baccarat1.png";
import BotHeadIcon5 from "../assets/images/vivo/icons/GalaxyBaccarat3.png";
import BotHeadIcon6 from "../assets/images/vivo/icons/galaxybaccarat2.png";
import BotHeadIcon7 from "../assets/images/vivo/icons/galaxyroulette.png";
import BotHeadIcon123 from "../assets/images/vivo/icons/Frenchroulette.png";
import { AiOutlineClose } from "react-icons/ai";
import Whatsapp from "../assets/images/Whatsapp.svg";
import Telegram from "../assets/images/Telegram.svg";
import Facebook from "../assets/images/facebook-512.svg";
import Instagram from "../assets/images/Instagram.svg";

import HomeIcon1 from "../assets/images/icons/headicons/home.png";
import SportsIcon1 from "../assets/images/icons/headicons/soccer.png";
import EzugiIcon1 from "../assets/images/icons/headicons/bet.png";
import SlotsIcon1 from "../assets/images/icons/headicons/jackpot.png";
import EvolutionIcon1 from "../assets/images/icons/headicons/cards.png";
import CashierIcon1 from "../assets/images/icons/headicons/dollar.png";
import SlotsImg from "../assets/images/games-icon/slot-machine.png";

import Logo from "../assets/images/logo.png";

const HeaderAfterLogin = () => {
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  // const betMatches = [
  //   {
  //     exposureAmount: 6438.5,
  //     matchName: "Australia v West Indies",
  //     refMatchId: 10,
  //     totalBets: 2,
  //   },
  // ];
  // const userBets = [
  //   {
  //     odds: 130,
  //     stack: 50,
  //     selectionType: "back",
  //     status: "open",
  //     createdAt: "2022-12-02T03:07:13.000Z",
  //   },
  //   {
  //     odds: 1.23,
  //     stack: 50,
  //     selectionType: "lay",
  //     status: "open",
  //     createdAt: "2022-12-02T03:07:04.000Z",
  //   },
  // ];
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showexchangeModal, setShowexchangeModal] = useState(false);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [visible, setVisible] = useState(true);
  const handleCloseModal = () => setShowexchangeModal(false);
  const handleShowModal = () => setShowexchangeModal(true);
  // function handelSubmit() {
  //   return <Index />;
  // }
  const [showToggle, setShowToggle] = useState(true);
  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);
  useEffect(() => {
    dispatch(getExposureAmount());
    dispatch(getBetMatches({ status: "pending" }));
    setShowToggle(window.screen.width > 992);
    return () => {};
  }, []);

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const [showLightModeToggle, setShowLightModeToggle] = useState(false);
  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  useEffect(() => {
    if (showLeftbarToggle) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  return (
    <>
      {visible ? (
        <div className="marqu">
          <marquee>GET BEST BONUS ON EVERY DEPOSIT!!</marquee>
          <span onClick={() => setVisible(!visible)}>
            <AiOutlineClose />
          </span>
        </div>
      ) : (
        ""
      )}
      <header className="header aftrlgn">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center header-section">
                <div className="d-flex align-items-center">
                  <div className="leftbar_toggle d-xl-none">
                    <Button
                      variant="primary"
                      onClick={() => setShowLeftbarToggle((s) => !s)}
                    >
                      <MenuIcon />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/home">
                      {/* <img src={appDetails?.LOGO_URL} alt="Logo" /> */}
                      <img src={Logo} alt="logo img" />
                    </a>
                  </div>
                </div>

                <Navbar expand="xl" className="d-none d-xl-block">
                  <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={() => setShowToggle((s) => !s)}
                  />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav>
                      <Nav.Link href="/home" className="logoImg d-xl-none">
                        <img src={appDetails?.LOGO_URL} alt="Logo" />
                      </Nav.Link>
                      <Nav.Link href="/home">
                        {/* <HomeIcon /> */}
                        <img src={HomeIcon1} alt="home icon" />
                        Home
                      </Nav.Link>
                      <Nav.Link href="/sports" className="blink">
                        {/* <SportsIcon className="" />  */}
                        <img src={SportsIcon1} alt="sports icon" />
                        Exchange
                      </Nav.Link>

                      <Nav.Link href={CasinoProviders["vivo"]?.href}>
                        {/* <GamesIcon />  */}
                        <img src={EzugiIcon1} alt="ezugi icon" />
                        Casino
                      </Nav.Link>
                      <Nav.Link href="/slots">
                        <img src={SlotsIcon1} alt="ezugi icon" />
                        Slots
                      </Nav.Link>

                      <Nav.Link href="/cashier">
                        {/* <CashierIcon />  */}
                        <img src={CashierIcon1} alt="cash icon" />
                        Cashier
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>

                <div className="headerRight">
                  <Dropdown align="end" className="me-2">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      Bal: <span>{numberWithCommas(wallet?.cash || 0)}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="tel:{user?.mobileno}">
                        <b>{user?.mobileno}</b>
                      </Dropdown.Item>
                      <Dropdown.Item href="javascript:void(0)">
                        <h6>Balance</h6>
                        <span>INR {numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="javascript:void(0)"
                        onClick={() => setShowBetModal(true)}
                      >
                        <h6>Exposure</h6>
                        <span>INR {numberWithCommas(exposureAmount || 0)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="javascript:void(0)">
                        <h6>Bonus</h6>
                        <span>INR {numberWithCommas(wallet?.coins)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/gatewaylist" className="deposit">
                        Deposit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div className="funds me-2">
                    <ul>
                      <li className="d-none d-md-block">
                        <a href="/gatewaylist" className="deposit">
                          Deposit
                        </a>
                      </li>
                    </ul>
                  </div>
                  <Button variant="primary menu-btn" onClick={handleShow}>
                    {/* <ProfileIcon /> */}
                    {/* <MenuIcon /> */}
                    <img src={UserIcon} alt="user icon" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Offcanvas show={show} onHide={handleClose} placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <ProfileIcon />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  <a href="tel:{user?.mobileno}">{user?.mobileno}</a>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row">
              <div className="col-6">
                <div className="balance mb-1">Main Balance</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-1">
                  {numberWithCommas(wallet?.cash || 0)}
                </div>
              </div>
              <div className="col-6">
                <div className="balance mb-3">Bonus</div>
              </div>
              <div className="col-6">
                <div className="balance-amount mb-3">
                  {numberWithCommas(wallet?.coins) || 0}
                </div>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/withdraw");
                }}
              >
                <Button variant="primary  w-100 withdrawBtn">Withdraw</Button>
              </div>
              <div
                className="col-6"
                onClick={() => {
                  navigate("/gatewaylist");
                }}
              >
                <Button variant="primary w-100">Deposit</Button>
              </div>
            </div>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <ProfileIcon />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <BetIcon />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <StatementIcon />
                  <span>Account Statement</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  <LogoutIcon />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links ">
              <li>
                <a
                  className="panel  social-icon"
                  href={
                    appDetails?.TELEGRAM != ""
                      ? appDetails?.TELEGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} alt="telegram icon" />
                </a>
              </li>

              <li>
                <a
                  className="panel  social-icon"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "javascript:void(0)"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  {/* <span className="notification-count">2</span> */}
                  <img src={Whatsapp} alt="whatsapp icon" />
                </a>
              </li>
              <li>
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.FACEBOOK != ""
                      ? appDetails?.FACEBOOK
                      : "javascript:void(0)"
                  }
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Facebook} alt="facebook" />
                </a>
              </li>
              <li>
                {" "}
                <a
                  className="panel social-icon watsapp"
                  href={
                    appDetails?.INSTATGRAM != ""
                      ? appDetails?.INSTATGRAM
                      : "javascript:void(0)"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} alt="instagram" />
                </a>
              </li>

              <li className="theme-btn">
                <buton
                  type="button"
                  onClick={() => setShowLightModeToggle((s) => !s)}
                >
                  <div className="theme-icon">
                    <img
                      src={MoonLight}
                      alt="Moon Icon"
                      className="dark_theme"
                    />
                    <img
                      src={SunLight}
                      alt="Sun Icon"
                      className="light_theme"
                    />
                  </div>
                </buton>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <div className="bottom_head">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul>
                  <li>
                    <a
                      onClick={() => {
                        navigate("/sports");
                      }}
                    >
                      <img src={BotHeadIcon1} alt="bottom head link icon" />
                      <span>Inplay</span>
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        navigate("/sports");
                      }}
                    >
                      <img src={BotHeadIcon2} alt="bottom head link icon" />
                      <span>Cricket</span>
                    </a>
                  </li>

                  <li className="d-block d-md-none">
                    <a href="/slots">
                      <img src={SlotsImg} alt="bottom head link icon" />
                      <span>Slots</span>
                    </a>
                  </li>

                  <li>
                    <a href="/casino/vivo-french-roulette">
                      <img src={BotHeadIcon123} alt="bottom head link icon" />
                      <span>French Roulette</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/vivo-galaxy-roulette">
                      <img src={BotHeadIcon4} alt="bottom head link icon" />
                      <span>Galaxy Roulette</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/vivo-galaxy-baccarat-3">
                      <img src={BotHeadIcon5} alt="bottom head link icon" />
                      <span>Galaxy Baccarat 3</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/vivo-galaxy-baccarat-2">
                      <img src={BotHeadIcon6} alt="bottom head link icon" />
                      <span>Galaxy Baccarat 2</span>
                    </a>
                  </li>
                  <li>
                    <a href="/casino/vivo-galaxy-baccarat-1">
                      <img src={BotHeadIcon7} alt="bottom head link icon" />
                      <span>Galaxy Baccarat 1</span>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
